




























































































































// TODO: Enable lint.
/* eslint-disable */
import { computed, defineComponent, reactive, SetupContext } from '@vue/composition-api';

import API from '@aws-amplify/api';
import Auth from '@aws-amplify/auth';

import NavHeader from '@/components/NavHeader.vue';
import Footer from '@/components/Footer.vue';

type Template = {
  id: string,
  name: string,
  created_at: string,
  updated_at: string,
  organization_id: string,
  is_vertical: boolean,
  has_description: boolean,
  has_image: boolean,
  has_spec: boolean,
};

type Project = {
  id: string,	
	organization_id: string,
	user_id: string,       
	name: string,         
	supplemental_memo: string,
	internal_memo: string,
  default_cp_template_id: string,
	is_archived: boolean,
	created_at: string,    
	updated_at: string,  
};

type Props = {
  pid: string;
};

export default defineComponent({
  name: "NewConcept",
  props: {
    pid: {
      type: String,
      default: ''
    }
  },
  components: {
    NavHeader,
    Footer
  },
  head: {
    link: [
      { rel: 'stylesheet', type: 'text/css', href: 'https://cdnjs.cloudflare.com/ajax/libs/spectrum/1.8.0/spectrum.min.css' },
      { rel: 'stylesheet', type: 'text/css', href: '/css/login/project.css' }
    ],
    script: [
      { src: "https://ajax.googleapis.com/ajax/libs/jquery/1.7/jquery.min.js" },
      { src: "/js/project.js" }
    ]
  },

  setup(props: Props, context: SetupContext) {
    const state = reactive({
      project: {} as Project,
      templates: [] as Template[],
      selected_template_id: '',

      concept: {
        name: '',
        project_id: props.pid,
        cp_template_id: ''
      },
    });

    async function load() {
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        }
      }

      API.get('dev', '/cptemplates', options).then(response => {
        console.log(response);
        state.templates = response.data;
        if (state.templates.length > 0) {
          state.selected_template_id = state.templates[0].id;
        }
      }).catch(err => {
        console.log(err);
      });

      API.get('dev', '/projects/' + props.pid, options).then(response => {
        console.log(response);
        state.project = response.data;
      }).catch(err => {
        console.log(err);
      });
    }
    load();

    async function createConcept() {
      state.concept.cp_template_id = state.selected_template_id;
      console.log(state);

      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        },
        body: state.concept
      }

      API.post('dev', '/concepts', options).then(response => {
        console.log(response);
        context.root.$router.push({ name: 'ConceptEdit', params: { id: response.data.id } });
      }).catch(err => {
        console.log(err);
      });
    }

    return {
      state,
      createConcept,
    };
  }

});
